export {
    detectDeviceLanguage,
    getFormattingLocale,
    default as i18n,
    isAppLanguage,
    SUPPORTED_LANGUAGES,
    SYSTEM_LANGUAGE
} from "./i18n";
export type { AppLanguage } from "./i18n";
export { I18nProvider, useLanguagePreference } from "./I18nProvider";
export { getStoredLanguage, setStoredLanguage } from "./languageStorage";
export { syncAndroidApplicationLocales } from "./syncAndroidApplicationLocales";

